// extracted by mini-css-extract-plugin
export var scrollArea = "_qf-0";